export const sortAndFilterResults = (places) => {
  const onlyPlaces = places.filter((place) => place.id.includes("place"));
  let placeOptions = [];
  onlyPlaces.forEach((place) => {
    placeOptions.push(place.place_name);
  });
  return placeOptions;
};
